// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"PartnerFormUI__wrapper___2kS_2","card":"PartnerFormUI__card___fCo6o","logo":"PartnerFormUI__logo___2uBqI","footer":"PartnerFormUI__footer___1EALy"};